import { ReactNode } from 'react';
import { SxStyle } from '../../types';
import Stack from '@mui/material/Stack';

const styles: SxStyle = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    position: 'relative',
    zIndex: 1,
  },
};

interface Props {
  children: ReactNode;
}

const GridOverlay = ({ children }: Props) => {
  return (
    <Stack sx={styles.container} spacing={2}>
      {children}
    </Stack>
  );
};

export default GridOverlay;
